import {createAsyncThunk} from '@reduxjs/toolkit';
import {billingAPI, IBillingStatus} from '../api';
import {handlerError} from '../../../store/handleError';

/**
 * Тянет актуальный billing-статус.
 * Используется:
 *  - при подключении WS (handleConnect)
 *  - при получении billing:status_changed
 *  - при HTTP 402 из axios-interceptor
 *  - fallback-polling раз в 5 минут
 *
 * Молча игнорирует ошибки (без модалки) — этот thunk дёргается часто,
 * спамить пользователя не надо.
 */
export const fetchBillingStatus = createAsyncThunk<IBillingStatus>(
    'billing/fetch_status',
    async (_, {rejectWithValue, getState}) => {
        // Не дёргаем balance-info до авторизации
        const token = localStorage.getItem('access_token');
        if (!token) {
            return rejectWithValue('not_authenticated');
        }
        try {
            return await billingAPI.getStatus();
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);